/**
 * CMS block banners for Black Friday page
 *
 * Content comes from Magento CMS blocks (admin-managed, trusted HTML).
 * decodeHtml from Theme handles entity decoding.
 */

import { decodeHtml } from '../../../Theme'
import { useBlackFriday } from '../../state'

import type { CmsBlockItem } from '../../types/graphql'

function BlockContent({ block }: { block: CmsBlockItem | null }) {
  if (!block) return null
  // CMS block content is admin-managed trusted HTML from Magento backend
  return <div dangerouslySetInnerHTML={{ __html: decodeHtml(block.content) }} />
}

export function Blocks() {
  const { blockData1, blockData2 } = useBlackFriday()

  return (
    <div className="mb-12">
      <BlockContent block={blockData1} />
      <BlockContent block={blockData2} />
    </div>
  )
}
